import React, { SVGProps } from 'react'

type PlayIconRoundedProps = {
  width?: string | number
  height?: string | number
  bgColor?: string
  arrowColor?: string
  borderColor?: string
} & SVGProps<SVGSVGElement>

const PlayIconRounded = ({
  width = '60',
  height = '60',
  bgColor = '#006FE4',
  arrowColor = '#FFF',
  borderColor = '#FFF',
  className,
  ...other
}: PlayIconRoundedProps) => (
  <svg
    className={`play-icon ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 96 96"
    {...other}
  >
    <g fill="none" fillRule="evenodd">
      <circle
        cx="48"
        cy="48"
        r="45.5"
        fill={bgColor}
        stroke={borderColor}
        strokeWidth="5"
      />
      <path
        fill={arrowColor}
        d="M28 28.582v38.836c0 1.657 1.343 3 3 3 .413 0 .821-.086 1.2-.25L76.699 50.75c1.518-.663 2.212-2.431 1.55-3.95-.303-.693-.857-1.247-1.55-1.55l-44.5-19.417c-1.518-.663-3.286.03-3.949 1.55-.165.378-.25.786-.25 1.2z"
      />
    </g>
  </svg>
)

export default PlayIconRounded
